import React from "react"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import * as z from "zod"


import { Checkbox } from "@/components/ui/checkbox"
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form"
import { toast } from "@/components/ui/use-toast"
import { Button } from "../ui/button"
import { useTranslation } from "react-i18next"
import { Textarea } from "../ui/textarea"

const feedbackCatItems = [
    {
        id: "layout",
        reportKey: "界面显示错误",
    },
    {
        id: "image",
        reportKey: "图片不符合标准",
    },
    {
        id: "content",
        reportKey: "介绍内容错误",
    },
    {
        id: "incomplete",
        reportKey: "资料不全",
    },
    {
        id: "others",
        reportKey: "其他",
    }
] as const


const ProductFeedbackForm = ({ productCode, onClose }: { productCode: string, onClose?: () => void }) => {
    const { t, i18n } = useTranslation()

    const FormSchema = z.object({
        categories: z.array(z.string()),
        description: z.string().min(1, {
            message: t("product-feedback-form.form-errors.description"),
        }),
    })

    const form = useForm<z.infer<typeof FormSchema>>({
        resolver: zodResolver(FormSchema),
        defaultValues: {
            categories: [],
            description: ""
        },
    })

    async function onSubmit(data: z.infer<typeof FormSchema>) {
        const currentUrl = window.location.href

        const reportData = { 
            catrgories: data.categories.map((c) => feedbackCatItems.find((i) => i.id === c).reportKey),
            url: currentUrl,
            productCode,
            description: data.description
        }

        await fetch("https://api.mingdao.com/workflow/hooks/NjRmMjhhNTE0Mzc3MjMwY2RlNjMyMWM4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reportData),
        })

        if (onClose) {
            onClose()
        }
        toast({
            title: t("product-feedback-form.submit-success")
        })
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="categories"
                    render={() => (
                        <FormItem>
                            <div className="mb-4">
                                <FormLabel className="text-base">{t('product-feedback-form.categories.title')}</FormLabel>
                            </div>
                            {feedbackCatItems.map((item) => (
                                <FormField
                                    key={item.id}
                                    control={form.control}
                                    name="categories"
                                    render={({ field }) => {
                                        return (
                                            <FormItem
                                                key={item.id}
                                                className="flex flex-row items-start space-x-3 space-y-0"
                                            >
                                                <FormControl>
                                                    <Checkbox
                                                        checked={field.value?.includes(item.id)}
                                                        onCheckedChange={(checked) => {
                                                            return checked
                                                                ? field.onChange([...field.value, item.id])
                                                                : field.onChange(
                                                                    field.value?.filter(
                                                                        (value) => value !== item.id
                                                                    )
                                                                )
                                                        }}
                                                    />
                                                </FormControl>
                                                <FormLabel className="font-normal">
                                                    {t(`product-feedback-form.categories.options.${item.id}`)}
                                                </FormLabel>
                                            </FormItem>
                                        )
                                    }}
                                />
                            ))}
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="description"
                    render={() => {
                        return (
                            <FormItem>
                                <div className="mb-4">
                                    <FormLabel className="text-base">{t('product-feedback-form.describe')}</FormLabel>
                                </div>
                                <FormControl>
                                    <Textarea
                                        className="w-full h-32"
                                        {...form.register("description")}
                                    />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )
                    }} />
                <Button type="submit">{t('product-feedback-form.submit')}</Button>
            </form>
        </Form>
    )
}

export default ProductFeedbackForm